export default "__VITE_ASSET__Cqo4YoNN__"